module.exports = __webpack_public_path__ + "static/media/copyIconWhite.41e317e3.svg";